export default __webpack_public_path__ + "static/media/logo3dsmax.3a08e399.png";